<div class="about">
    <div class="left-container">
        <img src="/assets/headshot2024.jpg">
    </div>
    <div class="right-container">
        <p>Anna Ladd makes nonfiction narrative + Weird Internet Art (sometimes both at the same time). Professionally, she is a podcast producer, a job she got by winning a reality show. Unprofessionally, she is a video essayist and visual artist. She is not a “content creator.” She is 6’ tall and can be found on a walk somewhere in South Philly.</p>
    </div>
</div>
